/*
 * @Author: zhujiapeng
 * @Email: zhujiapeng@xiaomai5.com
 * @Date: 2021-01-14 16:38:38
 * @Last Modified by: zhujiapeng
 * @Last Modified time: 2021-01-14 17:48:49
 * @Description: Description
 */

import React from 'react';
import PageControl from '../components/PageControl';
import AxiosTS from '../../core/axios';
import { Modal, Table, Tooltip } from 'antd';
import { formatDate } from '../../core/function';
import { secondToTimeStr } from '../../core/method';
import moment from 'moment';
import Permission from '../../core/permission';
import FaceImg from './FaceImg';

class SuccessSignInStudentModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      totalPage: 0,
      studentList: [],
      columns: [],
      query: {
        size: 10,
        current: 1,
        instId: window.currentUserInstInfo.instId,
        checkInStartDate: moment().startOf('day').valueOf(),
        checkInEndDate: moment().valueOf()
      }
    };
  }

  componentDidMount() {
    this.getColumns();
    this.fetchRecordList();
  }

  /**
   * 获取考勤记录列表
   */
  fetchRecordList = (current = 0) => {
    this.setState({
      loading: true
    });
    const { query } = this.state;
    query.current = current;
    this.setState({
      query
    });
    AxiosTS.Business('public/attendance/getAttendanceList', { ...query, current: query.current + 1 }).then((res) => {
      const list = res.result.records || [];
      this.setState({
        studentList: list,
        totalPage: res.result.total,
        loading: false
      });
    });
  }

  /**
   * 显示学员人脸考勤照片
   */
  faceImg = (resourceId) => {
    const modal = <FaceImg
      resourceId={resourceId}
      cancel={() => {
        this.setState({
          modal: null
        });
      }}
    />
    this.setState({
      modal
    });
  }

  /**
   * 设置表格的属性
   */
  getColumns() {
    const columns = [
      {
        title: '姓名',
        width: "10%",
        dataIndex: 'studentName',
        key: 'studentName'
      },
      {
        title: '手机号',
        width: "10%",
        dataIndex: 'phone',
        key: 'phone',
        render: (text, record) => {
          const { phone } = record;
          const hideStudentPhone = phone.substr(0, 3) + '****' + phone.substr(7);
          return (
            Permission.hasEduStudentPhone() ? phone : hideStudentPhone
          );
        }
      },
      {
        title: '今日签到时间',
        width: "20%",
        dataIndex: 'checkInTime',
        key: 'checkInTime',
        render: (text, record) => {
          const { checkInTime, checkInWay } = record;
          if (checkInTime) {
            if (checkInWay === 'FACE') {
              return (
                <div>
                  {checkInTime && formatDate('YYYY-MM-DD H:i', checkInTime)}
                  <a
                    onClick={() => {
                      this.faceImg(record.checkInProof);
                    }}
                  >
                    （刷脸）
                  </a>
                </div>
              );
            } else if (checkInWay === 'MANUAL') {
              return (
                <div>
                  {checkInTime && formatDate('YYYY-MM-DD H:i', checkInTime)}
                  （
                  <span>
                    <span>手动添加</span>
                    <Tooltip title={<span>操作人：{record.checkInOperatorName}</span>}>
                      <span className="icon iconfont" style={{ color: '#BFBFBF', marginLeft: 2 }}>&#xe6f0;</span>
                    </Tooltip>
                  </span>
                  ）
                </div>
              );
            } else {
              return (
                <div>
                  {checkInTime && formatDate('YYYY-MM-DD H:i', checkInTime)}
                  （刷卡）
                </div>
              );
            }
          }
        }
      },
      {
        title: '今日签退时间',
        dataIndex: 'remindTime',
        width: "20%",
        key: 'remindTimes',
        render: (text, record) => {
          const { checkOutTime, checkOutWay } = record;
          if (checkOutTime) {
            if (checkOutWay === 'FACE') {
              return (
                <div>
                  {checkOutTime && formatDate('YYYY-MM-DD H:i', checkOutTime)}
                  <a
                    onClick={() => {
                      this.faceImg(record.checkOutProof);
                    }}
                  >
                    （刷脸）
                </a>
                </div>
              );
            } else if (checkOutWay === 'MANUAL') {
              return (
                <div>
                  {checkOutTime && formatDate('YYYY-MM-DD H:i', checkOutTime)}
                  （
                  <span>
                    <span>手动添加</span>
                    <Tooltip title={<span>操作人：{record.checkOutOperatorName}</span>}>
                      <span className="icon iconfont" style={{ color: '#BFBFBF', marginLeft: 2 }}>&#xe6f0;</span>
                    </Tooltip>
                  </span>
                  ）
                </div>
              );
            } else {
              return (
                <div>
                  {checkOutTime && formatDate('YYYY-MM-DD H:i', checkOutTime)}
                  （刷卡）
                </div>
              );
            }
          }
        }
      },
      {
        title: '时长',
        dataIndex: 'tagList',
        width: "7%",
        key: 'tagList',
        render: (text, record) => {
          if (!!record.checkOutTime && !!record.checkInTime) {
            return (
              secondToTimeStr(parseInt(record.checkOutTime - record.checkInTime) / 1000)
            );
          }
        }
      }
    ];
    this.setState({
      columns
    });
  }

  render() {
    const columns = this.state.columns;
    return (
      <Modal
        className="success-signin-student-modal"
        width={'100rem'}
        title={this.props.title}
        visible={true}
        footer={null}
        onCancel={this.props.close}
      >
        <Table
          pagination={false}
          columns={columns}
          loading={this.state.loading}
          rowKey='id'
          size='small'
          dataSource={this.state.studentList}
        />
        <div style={{ marginTop: 20 }}>
          <PageControl
            size="small"
            current={this.state.query.current}
            pageSize={this.state.query.size}
            total={this.state.totalPage}
            toPage={(page) => {
              this.fetchRecordList(page);
            }}
          />
        </div>
        {this.state.modal}
      </Modal>
    )
  }
}

export default SuccessSignInStudentModal;